export default {
  GET_KUSPIT_FUNDING_DETAILS_QUERY: Symbol.for('GET_KUSPIT_FUNDING_DETAILS_QUERY'),
  KUSPIT_FUNDING_DETAILS_REPOSITORY: Symbol.for('KUSPIT_FUNDING_DETAILS_REPOSITORY'),
  KUSPIT_FUNDING_DETAILS_STATE_MANAGER: Symbol.for('KUSPIT_FUNDING_DETAILS_STATE_MANAGER'),
};
